"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const RuleEditor_1 = __importDefault(require("./RuleEditor"));
const util_1 = require("../../data/util");
const Preview_1 = __importDefault(require("./Preview"));
const gatsby_link_1 = __importDefault(require("gatsby-link"));
const Menu_1 = __importDefault(require("./Menu"));
const FullScreenView_1 = __importDefault(require("./FullScreenView"));
const share_1 = require("../../data/share");
const _examples_1 = __importDefault(require("../../data/examples/_examples"));
class Editor extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            project: [
                {
                    ruleKey: "A",
                    colour: "#4488ee",
                    operation: "root",
                    successors: { kind: "none" },
                    scale: 1.0
                }
            ],
            menuOpen: false,
            fullScreen: false,
            iterations: 8
        };
        this.addRule = () => {
            const { project } = this.state;
            const ruleNames = project.map(r => r.ruleKey);
            this.setState({
                project: [
                    ...project,
                    {
                        ruleKey: util_1.nextRuleName(ruleNames),
                        colour: "#4488ee",
                        successors: {
                            kind: "all",
                            rule: null
                        },
                        operation: "pop",
                        scale: 1.0
                    }
                ]
            });
        };
        this.updateColour = (idx, colour) => {
            const rule = this.state.project[idx];
            if (rule) {
                this.updateRule(idx, { ...rule, colour });
            }
        };
        this.updateOperation = (idx, operation) => {
            const rule = this.state.project[idx];
            if (rule) {
                this.updateRule(idx, { ...rule, operation });
            }
        };
        this.updateScale = (idx, scale) => {
            const rule = this.state.project[idx];
            if (rule) {
                this.updateRule(idx, { ...rule, scale });
            }
        };
        this.updateSuccessors = (idx, successors) => {
            const rule = this.state.project[idx];
            if (rule) {
                this.updateRule(idx, { ...rule, successors });
            }
        };
        this.updateRule = (idx, rule) => {
            this.setState({
                project: [
                    ...this.state.project.slice(0, idx),
                    rule,
                    ...this.state.project.slice(idx + 1)
                ]
            });
        };
        this.downloadProject = () => {
            const data = "data:text/json;charset=utf-8," +
                encodeURIComponent(JSON.stringify(this.state.project, null, 2));
            const downloadAnchorNode = document.createElement("a");
            downloadAnchorNode.setAttribute("href", data);
            downloadAnchorNode.setAttribute("download", "cs-export.json");
            document.body.appendChild(downloadAnchorNode); //firefox?
            downloadAnchorNode.click();
            downloadAnchorNode.remove();
        };
        this.load = (project) => this.setState({ project });
        this.resetProject = () => {
            const project = [
                [
                    {
                        ruleKey: "A",
                        colour: "#ee1930",
                        operation: "root",
                        successors: { kind: "none" },
                        scale: 1.0
                    }
                ],
                [
                    {
                        ruleKey: "A",
                        colour: "#3fcb58",
                        operation: "root",
                        successors: { kind: "none" },
                        scale: 0.5
                    }
                ],
                [
                    {
                        ruleKey: "A",
                        colour: "#4488ee",
                        operation: "tetraRoot",
                        successors: { kind: "none" },
                        scale: 0.8
                    }
                ]
            ][Math.floor(Math.random() * 3)];
            this.setState({ project });
        };
    }
    componentDidMount() {
        const project = share_1.extractStateFromUrl("rules");
        if (project && Array.isArray(project)) {
            this.setState({
                project,
                fullScreen: true
            });
        }
        else {
            const example = _examples_1.default[Math.floor(Math.random() * _examples_1.default.length)];
            this.setState({
                project: example.rules
            });
        }
    }
    render() {
        const shareLink = share_1.generateUrlForThisPage(this.state.project, "rules");
        if (this.state.fullScreen) {
            return (React.createElement(FullScreenView_1.default, { project: this.state.project, defaultIterationLimit: this.state.iterations, escape: () => this.setState({ fullScreen: false }), shareLink: shareLink }));
        }
        else {
            return (React.createElement("div", { className: "editor-container" },
                React.createElement("div", { className: "editor-bar" },
                    React.createElement("div", { style: {
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center"
                        } },
                        React.createElement(gatsby_link_1.default, { to: "/", style: { color: "white", fontSize: "1.2em", paddingRight: 40 } }, "Back"),
                        React.createElement("h2", null, "Code Sculpture Web")),
                    React.createElement("a", { onClick: () => this.setState({ menuOpen: true }), style: { color: "white", fontSize: "1.2em" } }, "\u2630 Menu")),
                React.createElement("div", { className: "editor" },
                    React.createElement(Preview_1.default, { project: this.state.project, iterationLimit: this.state.iterations }),
                    React.createElement("div", { className: "editControls" },
                        React.createElement("div", { className: "ruleEditors" }, this.state.project.map((r, i) => (React.createElement(RuleEditor_1.default, { key: r.ruleKey, isRoot: i === 0, rule: r, availableRules: this.state.project
                                .slice(1)
                                .map(r => r.ruleKey), updateColour: c => this.updateColour(i, c), updateOperation: c => this.updateOperation(i, c), updateScale: c => this.updateScale(i, c), updateSuccessors: c => this.updateSuccessors(i, c) })))),
                        React.createElement("div", { className: "buttons" },
                            React.createElement("div", { onClick: this.addRule, className: "addButton" },
                                React.createElement("span", null, "Add Rule")))),
                    React.createElement("div", { className: "inset-buttons-left" },
                        React.createElement("a", { className: "little-button", onClick: () => this.setState({ fullScreen: true }) }, "Fullscreen"),
                        React.createElement("a", { className: "little-button", onClick: () => alert("Coming soon") }, "VR"),
                        React.createElement("a", { className: "little-button", target: "_blank", href: shareLink }, "Share"))),
                React.createElement(Menu_1.default, { open: this.state.menuOpen, close: () => this.setState({ menuOpen: false }), project: this.state.project, download: this.downloadProject, load: this.load, iterations: this.state.iterations, setIterations: iterations => this.setState({ iterations }), resetProject: this.resetProject })));
        }
    }
}
exports.default = Editor;



// WEBPACK FOOTER //
// ./src/components/editor/Editor.tsx